import { Route, Routes } from 'react-router-dom';
import styles from './App.module.css';
import { Snackbar } from '../../../components/Snackbar/SnackbarContext';
import { TopAppBar } from '../../app/app-nav/TopAppBar';
import { CallLogs } from '../meeting-report/CallLogs';
import { CallReport } from '../meeting-report/CallReport';
import UsageDashboard from '../usage/UsageDashboard';
import MeetingHome from '../MeetingHome';
import { OutboundWhatsApp } from '../../whatsapp/outbound/OutboundWhatsApp';

export function App() {
  return (
    <div className={styles.app}>
      <Snackbar>
        <TopAppBar />
        <div className={styles.appContainer}>
          <Routes>
            <Route path="/" element={<MeetingHome />} />
            <Route path="/meeting-report/:meetingId/:pageParam" element={<CallLogs />} />
            <Route
              path="/meeting-fullreport/:meetingId/:pageParam/:reportId"
              element={<CallReport />}
            />
            <Route path="/meeting-usage/:meetingId" element={<UsageDashboard />} />
            <Route path="/outbound" element={<OutboundWhatsApp />} />
          </Routes>
        </div>
      </Snackbar>
    </div>
  );
}
